<template>
    <ConfigurationTour :tour-name-key="tourNameKey"
                 :tour-steps="tourSteps"
                 :tour-available="tourAvailable" />
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { userGuideService } from '../userGuideService'

    import ConfigurationTour from './ConfigurationTour.vue'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            ConfigurationTour,
        },
        data() {
            return {
                tourNameKey: "documnetActionsTour.tourName",
                tourSteps: userGuideService.getDocumentActions(),
            };
        },
    })
</script>
